import {
    mapActions,
    mapGetters,
    mapMutations
} from 'vuex';

export default {

    components: {},

    props: {
        data: Array,
    },

    computed: {
        ...mapGetters([
            'cart', 'priceHiddenMode'
        ]),
    },

    data() {
        return {

        };
    },

    watch: {
        data() {
            if (this.data.length > 0) {
                let interCart = this.data.filter(inter => {
                    let index = this.cart.findIndex(element => element.Code == inter.Code)
                    if (index >= 0) {
                        inter.LG_NbInter = this.cart[index].Quantite;
                    }
                    return index >= 0
                });
            }
        }
    },

    methods: {
        ...mapMutations([
            'setCart',
            'addArticle',
            'ArticleQuantityP',
            'ArticleQuantityM',
            'ArticleQuantityS',
            'removeArticle'
        ]),

        addQuantity(article) {
            let idCommande = '';
            let index = this.cart.findIndex(element => element.Code == article.Code)
            let indexInter = this.data.findIndex(inter => inter.Code == article.Code)
            this.data[indexInter].NbInter++;
            article.LG_NbInter++;
            if (index >= 0) {
                this.ArticleQuantityP(index);
            } else {
                idCommande = Math.random().toString(36)
                var commande = {
                    Code: article.Code,
                    Nom: article.Nom + " x5",
                    Quantite: article.LG_NbInter,
                    PU: parseFloat(article.PrixBaseHT*5),
                    PrixBaseHT: parseFloat(article.PrixBaseHT),
                    PT: parseFloat(article.LG_NbInter * 5 * article.PrixBaseHT),
                    Famille: article.Famille,
                    idCommande: idCommande,
                    Commentaire: '',
                    PLRef: '',
                    SocleChoose: false,
                    Sup: '',
                }
                this.addArticle(commande);
            }
            this.$emit('getIntersInCart');
        },

        changeQuantity(article) {
            let idCommande = '';
            if (article.LG_NbInter > 0) {
                let index = this.cart.findIndex(function (element) {
                    element.Code == article.Code
                })
                if (index >= 0) {
                    const infoQuantite = {
                        index: index,
                        quantity: article.LG_NbInter
                    }
                    this.ArticleQuantityS(infoQuantite);
                } else {
                    idCommande = Math.random().toString(36)
                    var commande = {
                        Code: article.Code,
                        Nom: article.Nom + " x5",
                        Quantite: article.LG_NbInter,
                        PU: parseFloat(article.PrixBaseHT * 5),
                        PrixBaseHT: parseFloat(article.PrixBaseHT),
                        PT: parseFloat(article.LG_NbInter * 5 * article.PrixBaseHT),
                        Famille: article.Famille,
                        idCommande: idCommande,
                        Commentaire: '',
                        PLRef: '',
                        SocleChoose: false,
                        Sup: '',
                    }
                    this.addArticle(commande);
                }
            } else {
                let index = this.cart.findIndex(element => element.Code == article.Code)
                if (index >= 0) {
                    this.removeArticle(index);
                }
            }
            this.$emit('getIntersInCart');
        },

        substractQuantity(article) {
            if (article.LG_NbInter > 0) {
                let index = this.cart.findIndex(element => element.Code == article.Code)
                article.LG_NbInter--;
                if (index >= 0) {
                    this.ArticleQuantityM(index);
                }
                this.$emit('getIntersInCart');
            }
        },

        imageExists(image_url) {

            var img = new Image();
            img.src = "../" + image_url;
            if (img.height != 0) {
                return true;
            } else {
                return false;
            }

        },
    },
    filters: {

    },

};
